export const THEME_STORAGE_KEY = "app-theme-preference";

export function applyDarkClass(isDarkMode: boolean): void {
  if (typeof document === "undefined") return;
  const root = document.documentElement;
  root.classList.toggle("dark", isDarkMode);
  root.style.colorScheme = isDarkMode ? "dark" : "light";
  if (isDarkMode) {
    root.setAttribute("data-swal2-theme", "dark");
  } else {
    root.removeAttribute("data-swal2-theme");
  }
}
